module.exports = __webpack_public_path__ + "img/hotline-profile-heino.117f0845.jpg";